import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { PaymentElement } from '@stripe/react-stripe-js';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
import { useBooleanState } from 'hooks/useBooleanState';
const cardElementStylesHasFocusCss = "cbohrb9";
const cardElementStylesHasErrorCss = "cvnd5uk";
const cardElementStylesCss = "cx5l8nt";
const CardElementStyles = forwardRef((props, ref) => {
  const {
    hasFocus,
    hasError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardElementStylesCss, {
    [cardElementStylesHasFocusCss]: hasFocus,
    [cardElementStylesHasErrorCss]: hasError
  }, props.className)} />;
});
const StripePaymentElementField = ({
  onChange,
  onReady,
  onEscape,
  error,
  disabled,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);
  const [hasFocus, focus, blur] = useBooleanState(false);
  const handleChange = changeObject => {
    setHasError(Boolean(changeObject.error));
    onChange(changeObject);
  };
  return <div {...props}>
      <FullStoryExclude>
        <CardElementStyles as={PaymentElement} hasError={hasError} hasFocus={hasFocus} onChange={handleChange} onFocus={focus} onBlur={blur} onReady={onReady} onEscape={onEscape} options={{
        disabled,
        fields: {
          billingDetails: 'never'
        }
      }} />
      </FullStoryExclude>
      <ErrorMessage message={error} />
    </div>;
};
export default StripePaymentElementField;

require("./payment_element.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_element.js");